export function CSVPrinter(data) {

    self = this;
    self.rootvm = data.rootvm;
    self.tmpColDelim = String.fromCharCode(11); // vertical tab character
    self.tmpRowDelim = String.fromCharCode(0); // null character


    // actual delimiter characters for CSV format
    self.colDelim = '","';
    self.rowDelim = '"\r\n"';

    /*
     *
     * Say we have a list of keys:
     * ['a', 'b', 'c']
     *
     * and we want to export them one line per item
     */
    self.exportArray = function (list_of_items) {
        var csv = '"';
        for (var i = 0; i < list_of_items.length; i++) {
            var item = list_of_items[i];

            csv += item;
            csv += self.rowDelim;
        }
        csv += '"';
        // Data URI
        var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);

        // For IE (tested 10+)
        if (window.navigator.msSaveOrOpenBlob) {
            var blob = new Blob([decodeURIComponent(encodeURI(csv))], {
                type: "text/csv;charset=utf-8;"
            });
            navigator.msSaveBlob(blob, 'translationkeys.csv');
        } else {
            // In Firefox this is not defined!
            $(event.target)
                .attr({
                    'download': 'translationkeys.csv',
                    'href': csvData,
                    'target': '_blank' //if you want it to open in a new window
                });
        }
    };

    self.exportArrays = function (list_of_items) {
        var csv = '"';
        for (var i = 0; i < list_of_items.length; i++) {
            var row = list_of_items[i];

            for (var j = 0; j < row.length; j++) {
                item = row[j];
                csv += item;
                csv += self.colDelim;
            }

            csv += self.rowDelim;
        }
        csv += '"';
        // Data URI
        var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);

        return csvData;
        /*
        // For IE (tested 10+)
        if (window.navigator.msSaveOrOpenBlob) {
            var blob = new Blob([decodeURIComponent(encodeURI(csv))], {
                type: "text/csv;charset=utf-8;"
            });
            navigator.msSaveBlob(blob, 'translationkeys.csv');
        } else {
            // In Firefox this is not defined!
            $(event.target)
                .attr({
                    'download':'translationkeys.csv',
                    'href': csvData
                    ,'target' : '_blank' //if you want it to open in a new window
            });
        }
        */
    };

    // Export to CSV
    self.exportTableToCSV = function (context, tableIDs, filename) {
        var csv = '"';
        for (var i = 0; i < tableIDs.length; i++) {
            var $table = $('#' + tableIDs[i]);

            var $headers = $table.find('tr:has(th)'), $rows = $table.find('tr:has(td)');

            // Grab text from table into CSV formatted string
            csv += self.formatRows($headers.map(self.grabRow));
            csv += self.rowDelim;
            csv += self.formatRows($rows.map(self.grabRow));
            csv += self.rowDelim;

        }

        csv += '"';

        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };


    //------------------------------------------------------------
    // Helper Functions
    //------------------------------------------------------------
    // Format the output so it has the appropriate delimiters
    self.formatRows = function (rows) {
        return rows.get().join(self.tmpRowDelim)
            .split(self.tmpRowDelim).join(self.rowDelim)
            .split(self.tmpColDelim).join(self.colDelim);
    };
    // Grab and format a row from the table
    self.grabRow = function (i, row) {

        var $row = $(row);

        if (!$row.hasClass('no-csv')) {
            //for some reason $cols = $row.find('td') || $row.find('th') won't work...
            var $cols = $row.find('td');
            if (!$cols.length) $cols = $row.find('th');

            return $cols.map(self.grabCol)
                .get().join(self.tmpColDelim);
        }
    };

    // Grab and format a column from the table
    self.grabCol = function (j, col) {
        var $col = $(col);
        var $text = null;

        // We might have a whole bunch of spans
        if ($col.find('.to-print').length >= 1) {
            $text = $col.find('.to-print').text();
        }
        else if ($col.find('strong').length >= 1) {
            $text = $col.find('strong').text();
        }
        else if ($col.find('span').length > 1) {
            $text = $col.find('span').first().text();
        }
        else if ($col.find('span.show-only-print').length > 0) {
            $text = $col.find('span').first().text();
        }
        else if ($col.find('button').length > 0) {
            $text = "";
        }
        else {
            $text = $col.text();
        }
        // strip Line breaks
        $text = $text.replace(/(\r\n|\n|\r)/gm, "");
        $text = $text.trim();
        return $text.replace('"', '""'); // escape double quotes
    };
}
;
